import { Component, OnInit } from '@angular/core';
import { EnvironmentConfiguration } from 'app/environment/services/environment.configuration';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'pioneer-external-login-expired',
  templateUrl: './external-login-expired.component.html'
})
export class ExternalLoginExpiredComponent implements OnInit {

  constructor(private environment: EnvironmentConfiguration,
    private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    if (this.route.snapshot.queryParamMap.get('redirect') !== null) {
      setTimeout(() => {
        location.href = this.environment.portalUrl + this.environment.portalLogout;
      }, this.environment.portalRedirectTimer);
    }
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/auth/external-login-expired/external-login-expired.component.ts